export default __webpack_public_path__ + "static/media/Orlovsky_Viktor_Mikhailovich.05699c85.webp";